import React, { useState } from "react";
import "../styles/ContactForm.css";
import contentData from "../data/content.json";
import youtubeIcon from "../assets/icons/social/youtube.svg";
import instagramIcon from "../assets/icons/social/instagram.svg";
import telegramIcon from "../assets/icons/social/telegram.svg";
import whatsappIcon from "../assets/icons/social/whatsapp.svg";

const ContactForm = () => {
    const { contact } = contentData;

    // Icon mapping
    const iconMap = {
        youtube: youtubeIcon,
        instagram: instagramIcon,
        telegram: telegramIcon,
        whatsapp: whatsappIcon,
    };

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        purpose: "",
        message: "",
    });
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: "",
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = "Name is required";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email is invalid";
        }

        if (!formData.purpose) {
            newErrors.purpose = "Please select a purpose";
        }

        if (!formData.message.trim()) {
            newErrors.message = "Message is required";
        } else if (formData.message.trim().length < 10) {
            newErrors.message = "Message must be at least 10 characters";
        }

        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = validateForm();

        if (Object.keys(newErrors).length === 0) {
            // Form is valid - handle submission
            // For now, just show success message
            // TODO: Integrate with actual email service (Formspree, EmailJS, etc.)
            console.log("Form submitted:", formData);
            setSubmitted(true);
            setFormData({
                name: "",
                email: "",
                purpose: "",
                message: "",
            });

            // Reset success message after 5 seconds
            setTimeout(() => {
                setSubmitted(false);
            }, 5000);
        } else {
            setErrors(newErrors);
        }
    };

    return (
        <div className="contact-form-container">
            <div className="contact-content">
                {/* Contact Info */}
                <div className="contact-info">
                    <h2 className="contact-info-title">Let's Connect</h2>
                    <p className="contact-info-text">
                        Have a question, collaboration idea, or just want to say hello?
                        I'd love to hear from you! Fill out the form and I'll get back to you as soon as possible.
                    </p>

                    {/* Social Links */}
                    <div className="social-links">
                        <h3 className="social-title">Follow My Journey</h3>
                        <div className="social-icons">
                            {contact.social.map((social, index) => (
                                <div key={index} className="social-item">
                                    <a
                                        href={social.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-link"
                                        aria-label={social.platform}
                                    >
                                        <img
                                            src={iconMap[social.icon]}
                                            alt={social.platform}
                                            className="social-icon"
                                        />
                                        {social.platform}
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Contact Form */}
                <div className="contact-form">
                    <form onSubmit={handleSubmit}>
                        {submitted && (
                            <div className="success-message">
                                ✓ Thank you! Your message has been sent successfully.
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="name" className="form-label">
                                Name *
                            </label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`form-input ${errors.name ? "error" : ""}`}
                                placeholder="Your full name"
                            />
                            {errors.name && <span className="error-text">{errors.name}</span>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="email" className="form-label">
                                Email *
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`form-input ${errors.email ? "error" : ""}`}
                                placeholder="your.email@example.com"
                            />
                            {errors.email && <span className="error-text">{errors.email}</span>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="purpose" className="form-label">
                                Purpose *
                            </label>
                            <select
                                id="purpose"
                                name="purpose"
                                value={formData.purpose}
                                onChange={handleChange}
                                className={`form-select ${errors.purpose ? "error" : ""}`}
                            >
                                <option value="">Select a purpose</option>
                                {contact.purposes.map((purpose, index) => (
                                    <option key={index} value={purpose}>
                                        {purpose}
                                    </option>
                                ))}
                            </select>
                            {errors.purpose && <span className="error-text">{errors.purpose}</span>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="message" className="form-label">
                                Message *
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                className={`form-textarea ${errors.message ? "error" : ""}`}
                                placeholder="Tell me about your inquiry..."
                                rows="6"
                            />
                            {errors.message && <span className="error-text">{errors.message}</span>}
                        </div>

                        <button type="submit" className="form-submit">
                            Send Message
                        </button>
                    </form>
                </div>
            </div >
        </div >
    );
};

export default ContactForm;
